export class DriverAssignDeliverd{
    InvoiceIds: number[];
    DriverId: number;
}